import { TimezonePreset } from './types';

export const TIMEZONE_PRESETS: TimezonePreset[] = [
  { label: "India Standard Time (IST, UTC+5:30)", offset: 330, id: "Asia/Kolkata" },
  { label: "UTC / GMT (London, UTC+0:00)", offset: 0, id: "Europe/London" },
  { label: "US Eastern Time (EST/EDT, UTC-5:00)", offset: -300, id: "America/New_York" },
  { label: "US Central Time (CST/CDT, UTC-6:00)", offset: -360, id: "America/Chicago" },
  { label: "US Mountain Time (MST/MDT, UTC-7:00)", offset: -420, id: "America/Denver" },
  { label: "US Pacific Time (PST/PDT, UTC-8:00)", offset: -480, id: "America/Los_Angeles" },
  { label: "Central European Time (CET/CEST, UTC+1:00)", offset: 60, id: "Europe/Paris" },
  { label: "Gulf Standard Time (Dubai/UAE, UTC+4:00)", offset: 240, id: "Asia/Dubai" },
  { label: "Singapore / Malaysia / China (SGT/CST, UTC+8:00)", offset: 480, id: "Asia/Singapore" },
  { label: "Japan Standard Time (JST, Tokyo, UTC+9:00)", offset: 540, id: "Asia/Tokyo" },
  { label: "Australian Eastern Time (AEST/AEDT, UTC+10:00)", offset: 600, id: "Australia/Sydney" },
  { label: "New Zealand Time (NZST/NZDT, UTC+12:00)", offset: 720, id: "Pacific/Auckland" },
  { label: "Brazil / Sao Paulo (BRT, UTC-3:00)", offset: -180, id: "America/Sao_Paulo" },
];

export const WESTERN_ZODIAC_SIGNS = [
  { sign: 'Capricorn', emoji: '♑', element: 'Earth', start: [1, 1], end: [1, 19], dates: 'Dec 22 – Jan 19' },
  { sign: 'Aquarius', emoji: '♒', element: 'Air', start: [1, 20], end: [2, 18], dates: 'Jan 20 – Feb 18' },
  { sign: 'Pisces', emoji: '♓', element: 'Water', start: [2, 19], end: [3, 20], dates: 'Feb 19 – Mar 20' },
  { sign: 'Aries', emoji: '♈', element: 'Fire', start: [3, 21], end: [4, 19], dates: 'Mar 21 – Apr 19' },
  { sign: 'Taurus', emoji: '♉', element: 'Earth', start: [4, 20], end: [5, 20], dates: 'Apr 20 – May 20' },
  { sign: 'Gemini', emoji: '♊', element: 'Air', start: [5, 21], end: [6, 20], dates: 'May 21 – Jun 20' },
  { sign: 'Cancer', emoji: '♋', element: 'Water', start: [6, 21], end: [7, 22], dates: 'Jun 21 – Jul 22' },
  { sign: 'Leo', emoji: '♌', element: 'Fire', start: [7, 23], end: [8, 22], dates: 'Jul 23 – Aug 22' },
  { sign: 'Virgo', emoji: '♍', element: 'Earth', start: [8, 23], end: [9, 22], dates: 'Aug 23 – Sep 22' },
  { sign: 'Libra', emoji: '♎', element: 'Air', start: [9, 23], end: [10, 22], dates: 'Sep 23 – Oct 22' },
  { sign: 'Scorpio', emoji: '♏', element: 'Water', start: [10, 23], end: [11, 21], dates: 'Oct 23 – Nov 21' },
  { sign: 'Sagittarius', emoji: '♐', element: 'Fire', start: [11, 22], end: [12, 21], dates: 'Nov 22 – Dec 21' },
  { sign: 'Capricorn', emoji: '♑', element: 'Earth', start: [12, 22], end: [12, 31], dates: 'Dec 22 – Jan 19' },
];

export const VEDIC_RASIS = [
  { name: "Mesha (Aries)", emoji: "♈", element: "Fire" },
  { name: "Vrishabha (Taurus)", emoji: "♉", element: "Earth" },
  { name: "Mithuna (Gemini)", emoji: "♊", element: "Air" },
  { name: "Karka (Cancer)", emoji: "♋", element: "Water" },
  { name: "Simha (Leo)", emoji: "♌", element: "Fire" },
  { name: "Kanya (Virgo)", emoji: "♍", element: "Earth" },
  { name: "Tula (Libra)", emoji: "♎", element: "Air" },
  { name: "Vrishchika (Scorpio)", emoji: "♏", element: "Water" },
  { name: "Dhanu (Sagittarius)", emoji: "♐", element: "Fire" },
  { name: "Makara (Capricorn)", emoji: "♑", element: "Earth" },
  { name: "Kumbha (Aquarius)", emoji: "♒", element: "Air" },
  { name: "Meena (Pisces)", emoji: "♓", element: "Water" },
];

export const VEDIC_NAKSHATRAS = [
  "Ashwini", "Bharani", "Krittika", "Rohini", "Mrigashira", "Ardra",
  "Punarvasu", "Pushya", "Ashlesha", "Magha", "Purva Phalguni", "Uttara Phalguni",
  "Hasta", "Chitra", "Swati", "Vishakha", "Anuradha", "Jyeshtha",
  "Mula", "Purva Ashadha", "Uttara Ashadha", "Shravana", "Dhanishta", "Shatabhisha",
  "Purva Bhadrapada", "Uttara Bhadrapada", "Revati"
];

export const CHINESE_ZODIAC_ANIMALS = [
  { animal: 'Rat', emoji: '🐀' },
  { animal: 'Ox', emoji: '🐂' },
  { animal: 'Tiger', emoji: '🐅' },
  { animal: 'Rabbit', emoji: '🐇' },
  { animal: 'Dragon', emoji: '🐉' },
  { animal: 'Snake', emoji: '🐍' },
  { animal: 'Horse', emoji: '🐎' },
  { animal: 'Goat', emoji: '🐐' },
  { animal: 'Monkey', emoji: '🐒' },
  { animal: 'Rooster', emoji: '🐓' },
  { animal: 'Dog', emoji: '🐕' },
  { animal: 'Pig', emoji: '🐖' },
];

export const CHINESE_ZODIAC_ELEMENTS = ['Wood', 'Fire', 'Earth', 'Metal', 'Water'];

export const BIRTH_GEMS_AND_FLOWERS = [
  { birthstone: '💎 Garnet', birthFlower: '🌸 Carnation' },
  { birthstone: '💎 Amethyst', birthFlower: '🌸 Violet' },
  { birthstone: '💎 Aquamarine', birthFlower: '🌸 Daffodil' },
  { birthstone: '💎 Diamond', birthFlower: '🌸 Daisy' },
  { birthstone: '💎 Emerald', birthFlower: '🌸 Lily of the Valley' },
  { birthstone: '💎 Pearl', birthFlower: '🌸 Rose' },
  { birthstone: '💎 Ruby', birthFlower: '🌸 Water Lily' },
  { birthstone: '💎 Peridot', birthFlower: '🌸 Poppy' },
  { birthstone: '💎 Sapphire', birthFlower: '🌸 Morning Glory' },
  { birthstone: '💎 Opal', birthFlower: '🌸 Marigold' },
  { birthstone: '💎 Topaz', birthFlower: '🌸 Chrysanthemum' },
  { birthstone: '💎 Turquoise', birthFlower: '🌸 Narcissus' },
];
